module.exports = __webpack_public_path__ + "img/xb-logo.a0bd864c.png";